import Base from 'app/collections/base';
import { appUrl } from 'utils/wrappers';
import Subscription from 'app/models/subscription';

export const SUBSCRIPTION_ACTIVE_STATUSES = [
  'trialing',
  'active',
  'past_due',
  'unpaid',
];

export const SHIPPING_SUBSCRIPTION_TYPE = 'shipping';


export default Base.extend({
  model: Subscription,
  url: appUrl('subscriptions'),

  comparator: 'status',

  hasActiveShippingSub() {
    return !!this.filter(m => (
      m.get('plan_product_type') === SHIPPING_SUBSCRIPTION_TYPE &&
      SUBSCRIPTION_ACTIVE_STATUSES.includes(m.get('status'))
    )).length;
  },
});



// WEBPACK FOOTER //
// ./app/collections/subscriptions.js